import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AfmOther } from '../models/afm-other.model';
import { AfmOtherService } from '../service/afm-other.service';
var EditGaTransientComponent = /** @class */ (function () {
    function EditGaTransientComponent(_matDialogRef, data, _afmOtherService) {
        this._matDialogRef = _matDialogRef;
        this._afmOtherService = _afmOtherService;
        this.isNew = false;
        this.isLoading = false;
        this.afmOther = data.afmOther || new AfmOther();
        this.isNew = data.isNew || false;
        this.airportID = data.airID;
        this.originalAfmOther = Object.assign(new AfmOther(), data.afmOther);
        this.itemsToChange = new Set();
        if (this.afmOther.gatParking === true) {
            this.selectedGatParking = 'Yes';
        }
        else if (this.afmOther.gatParking === false) {
            this.selectedGatParking = 'No';
        }
        else {
            this.selectedGatParking = 'Unknown';
        }
        this.selectedGatCharted = this.afmOther.gatCharted ? this.afmOther.gatCharted : false;
        this.selectedGatDescription = this.afmOther.gatDescription ? this.afmOther.gatDescription : '';
    }
    EditGaTransientComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            parking: new FormControl(this.selectedGatParking),
            charted: new FormControl(this.selectedGatCharted),
            description: new FormControl(this.selectedGatDescription, [Validators.maxLength(150)])
        });
        if (this.selectedGatParking === 'Unknown' || this.selectedGatParking === 'No') {
            this.formGroup.controls.description.disable();
        }
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditGaTransientComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        res = void 0;
                        if (this.formGroup.controls.parking.value === 'Yes') {
                            this.afmOther.gatParking = true;
                        }
                        else if (this.formGroup.controls.parking.value === 'No') {
                            this.afmOther.gatParking = false;
                        }
                        else {
                            this.afmOther.gatParking = null;
                        }
                        if (this.afmOther.gatParking) {
                            this.afmOther.gatCharted = this.formGroup.controls.charted.value;
                            if (this.formGroup.get('description').value.length > 0) {
                                this.afmOther.gatDescription = this.formGroup.get('description').value;
                            }
                            else {
                                this.afmOther.gatDescription = null;
                            }
                        }
                        else {
                            this.afmOther.gatCharted = false;
                            this.afmOther.gatDescription = null;
                        }
                        return [4 /*yield*/, this._afmOtherService.putAfmOther(this.airportID, this.afmOther)];
                    case 1:
                        res = _a.sent();
                        Object.assign(this.afmOther, AfmOther.parse(res));
                        this.afmOther = AfmOther.parse(res);
                        this.close({ cancelBtnClicked: false, success: true, afmOther: this.afmOther });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditGaTransientComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditGaTransientComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.afmOther, this.originalAfmOther);
        }
        this._matDialogRef.close(data);
    };
    return EditGaTransientComponent;
}());
export { EditGaTransientComponent };
